import { ReactNode, useEffect } from "react";
import { useAuth } from "../hooks/useAuth";
import { UnauthenticatedLocaleProvider } from "../providers/UnauthenticatedLocaleProvider";
import { AuthenticatedLocaleProvider } from "../providers/AuthenticatedLocaleProvider";
import { useDocumentationAreaIdAndActorId } from "../hooks/useDocumentationAreaIdAndActorId";
import { HTTPError } from "src/contexts/_shared/domain/errors/HTTPError";

export const AuthEnvironmentGate = ({ children }: { children: ReactNode }) => {
  const { token, deleteToken } = useAuth();
  const { documentationAreaIdError } = useDocumentationAreaIdAndActorId();

  useEffect(() => {
    const unauthorized =
      documentationAreaIdError &&
      documentationAreaIdError instanceof HTTPError &&
      documentationAreaIdError.getHTTPCode().isUnauthorized();

    if (unauthorized) {
      deleteToken();
    }
  }, [documentationAreaIdError]);

  if (token) {
    return <AuthenticatedLocaleProvider>{children}</AuthenticatedLocaleProvider>;
  }
  return <UnauthenticatedLocaleProvider>{children}</UnauthenticatedLocaleProvider>;
};
